import React from 'react'
import ButtonLogin from '../ButtonLogin/ButtonLogin'
import Or from '../Or/Or'

const WelcomeForm = ({
    onLoginButtonPress,
    onRegisterButtonPress,
}) => {
    return (
        <>
            <p style={{
                marginBottom: '48px',
                marginTop: '0px',
                fontSize: '24px',
                color: '#A29BFE'
            }}>
                Start your hebrew journey
            </p>
            <ButtonLogin
                onClick={onLoginButtonPress}
                style={{
                    backgroundColor: '#F4F4F4',
                    color: '#309CFF',
                }}
                title={"Log in"} />
            <Or />
            <ButtonLogin
                onClick={onRegisterButtonPress}
                style={{
                    backgroundColor: '#309CFF',
                    color: 'white',
                }}
                title={"Create Account"} />
        </>
    )
}

export default WelcomeForm
